module.exports = __webpack_public_path__ + "static/media/Payment Gateway.177296c9.svg";